import React from 'react';
import { token } from '@atlaskit/tokens';
import type { ViewBoxRect } from './ListEdgeDetails.tsx';
import { DATA_ATTRIBUTE_IGNORE_AUTOFIT } from './getVerticalOffset.tsx';

type Props = { viewBox: ViewBoxRect };

const ViewOverlay = ({ viewBox }: Props) => (
	<rect
		{...DATA_ATTRIBUTE_IGNORE_AUTOFIT}
		x={viewBox.left}
		y={viewBox.top}
		width={viewBox.width}
		height={viewBox.height}
		fill={token('elevation.surface')}
		fillOpacity="0.5"
	/>
);

export default ViewOverlay;
